// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__osfjw","spin":"PrintLink_spin__gQ8h3"};